import { useFretboardConfigStore } from '@/features/fretboard-base';
import React from 'react';

interface FretWidthBaseSelectorProps {
  minWidth?: number;
  maxWidth?: number;
  step?: number;
}

export const FretWidthBaseSelector: React.FC<FretWidthBaseSelectorProps> = ({
  minWidth = 20,
  maxWidth = 100,
  step = 1,
}) => {
  const fretWidthBase = useFretboardConfigStore((state) => state.fretWidthBase);
  const setFretWidthBase = useFretboardConfigStore((state) => state.setFretWidthBase);
  const useEqualTemperament = useFretboardConfigStore((state) => state.useEqualTemperament);

  // Dynamic label and description based on spacing mode
  const label = useEqualTemperament ? 'Last Fret Width' : 'Fret Width';

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newWidth = parseFloat(e.target.value);
    if (!isNaN(newWidth)) {
      setFretWidthBase(Math.max(minWidth, Math.min(maxWidth, newWidth)));
    }
  };

  return (
    <div className="form-control w-full mb-3 max-w-full">
      <label className="label">
        <span className="label-text">{label}</span>
        <span className="label-text-alt">{fretWidthBase}px</span>
      </label>
      <div className="flex gap-3 items-center">
        <input
          type="range"
          className="range range-primary flex-grow"
          value={fretWidthBase}
          onChange={handleChange}
          min={minWidth}
          max={maxWidth}
          step={step}
        />
        <input
          type="number"
          className="input input-bordered input-sm w-20 min-w-18"
          value={fretWidthBase}
          onChange={handleChange}
          min={minWidth}
          max={maxWidth}
          step={step}
        />
      </div>
    </div>
  );
};
